import { Box, Button, CircularProgress } from "@mui/material";
import { useContextualNavigate } from "../../hooks/ContextualNavigations";

export interface SecondaryAction {
  label: string;
  to?: string; // navega via useContextualNavigate (preserva a query)
  onClick?: () => void; // ação custom (ex.: reenviar código)
  loading?: boolean; // em andamento: mostra progresso e desabilita (evita duplo envio)
}

interface BrandedSecondaryActionProps {
  actions: SecondaryAction[];
}

// Ação(ões) secundária(s) das telas Branded, como botão(ões) de texto abaixo do primário
// (não seta no topo). `to` navega preservando a query; `onClick` dispara ação custom.
// `loading` desabilita e indica progresso (equivale ao LinearProgress da Default no
// "Reenviar código"). Cores vêm do tema; sem hex.
export const BrandedSecondaryAction: React.FC<BrandedSecondaryActionProps> = ({ actions }) => {
  const navigate = useContextualNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      {actions.map((action) => (
        <Button
          key={action.label}
          variant="text"
          color="primary"
          disabled={action.loading}
          startIcon={
            action.loading ? <CircularProgress size={16} color="inherit" /> : undefined
          }
          onClick={() => (action.onClick ? action.onClick() : action.to && navigate(action.to))}
          sx={{ textTransform: "none", fontWeight: 600, fontSize: "1.4rem", py: 0.5 }}
        >
          {action.label}
        </Button>
      ))}
    </Box>
  );
};
